import { __rest } from "tslib";
import * as React from 'react';
import { css } from '@patternfly/react-styles';
import styles from '@patternfly/react-styles/css/layouts/Level/level';
export var Level = function Level(_a) {
  var hasGutter = _a.hasGutter,
      _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      _a$children = _a.children,
      children = _a$children === void 0 ? null : _a$children,
      props = __rest(_a, ["hasGutter", "className", "children"]);

  return React.createElement("div", Object.assign({}, props, {
    className: css(styles.level, hasGutter && styles.modifiers.gutter, className)
  }), children);
};